import { NgModule } from '@angular/core';
import { APOLLO_OPTIONS } from 'apollo-angular';
import { ApolloClientOptions, InMemoryCache, split } from '@apollo/client/core';
import { HttpLink } from 'apollo-angular/http';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { createClient } from 'graphql-ws';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import { environment } from 'env';
import { AngularFireAuth } from '@angular/fire/compat/auth';

const http_uri = environment.httpUri;
const ws_uri = environment.wsUri;

export function createApollo(httpLink: HttpLink, afAuth: AngularFireAuth): ApolloClientOptions<any> {
    // Middleware pour ajouter les cookies et l'autorisation
    const authLink = setContext(async (_, { headers }) => {
        // Récupérer le token Firebase ici
        const firebaseUser = await afAuth.currentUser;
        const token = firebaseUser ? await firebaseUser.getIdToken() : null;

        const getCsrfToken = (): string | undefined => {
            const csrfCookie = document.cookie
                .split(';')
                .find(cookie => cookie.trim().startsWith('csrftoken='));
            return csrfCookie ? csrfCookie.split('=')[1] : undefined;
        };

        const csrfToken = getCsrfToken();
        return {
            headers: {
                ...headers,
                Authorization: token ? `Bearer ${token}` : '',
                'X-CSRFToken': csrfToken || '',
            }
        };
    });

    // query and mutations link
    const http = authLink.concat(httpLink.create({ uri: http_uri }));

    const ws = new GraphQLWsLink(
        createClient({
            url: ws_uri,
            connectionParams: async () => {
                const firebaseUser = await afAuth.currentUser;
                const token = firebaseUser ? await firebaseUser.getIdToken() : null;

                return {
                    headers: {
                        Authorization: token ? `Bearer ${token}` : '',
                    },
                };
            },
            on: {
                connected: () => console.log('[GraphQL WS] Connected'),
                closed: (event) => console.log('[GraphQL WS] Closed', event),
                error: (err) => console.error('[GraphQL WS] Error', err)
            }
        })
    );

    // find the correct operation in the query and return the correct link
    const link = split(
        ({ query }) => {
            return (
                query.definitions[0].kind === 'OperationDefinition' &&
                query.definitions[0].operation === 'subscription'
            );
        },
        ws,
        http
    );

    const links = onError(({ graphQLErrors, networkError }) => {
        if (graphQLErrors)
            graphQLErrors.map(({ message, locations, path }) =>
                console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
            );

        if (networkError) console.log(`[Network error]: ${networkError}`);
    });

    return {
        link: links.concat(link),
        cache: new InMemoryCache(),
    };
}
